import React from "react";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
}

const TRANSLATION_KEY =
  "settings.partners.generalTab.partnerPortal.enableModal";

const EnablePartnersModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  onConfirm
}) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      setIsOpen={setIsOpen}
      data-test="enable-partners-modal"
      contentClassname="w-[35rem]"
      title={
        <Text as="div" variant="lgSubtitleH1">
          {t(`${TRANSLATION_KEY}.title`)}
        </Text>
      }
      content={
        <div className="p-4">
          <Text variant="bodySecondary">
            {t(`${TRANSLATION_KEY}.description`)}
          </Text>
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant="secondary"
            onClick={handleCancel}
            data-test="enable-partners-modal-cancel"
          >
            {t(`${TRANSLATION_KEY}.cancel`)}
          </Button>
          <Button
            onClick={handleConfirm}
            data-test="enable-partners-modal-confirm"
          >
            {t(`${TRANSLATION_KEY}.confirm`)}
          </Button>
        </div>
      }
    />
  );
};

export default EnablePartnersModal;
